import React from 'react';

import PopOverCell from './PopOverCell';
import { Link } from 'components/SvgIcons';
import { getLiteral } from 'utils/getLiteral';

const PopOverCellAddLink = ({ enabled = true, ...props }) => {
    const { handleOnClick, permission } = props;
    return (
        <PopOverCell
            enabled={enabled}
            icon={<Link />}
            text={getLiteral('action_add_link')}
            onClick={permission && handleOnClick()}
        />
    );
};

export default PopOverCellAddLink;
